export default __webpack_public_path__ + "static/media/talksIcon.b97b07b2.svg";